import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpStatusCode, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly translateService = inject(TranslateService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //list of error statuses that should not trigger the error dialog
    const excludedErrorStatuses = [HttpStatusCode.NotFound];
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        //temporary fix for unavailable tickets error
        if (error?.error?.message === "Tickets are not available") {
          this.confirmationService.confirm({
            key: "errorDialog",
            header: this.translateService.instant("HOME.error_occurred_header"),
            message: this.translateService.instant("HOME.error_message_unavailable_ticket"),
            closable: false,
            rejectVisible: false,
            acceptButtonProps: {
              label: this.translateService.instant("HOME.close"),
              severity: 'secondary',
              outlined: true,
              align: 'center'
            },
          });
          return throwError(() => error);
        }
        const skipErrorModal = request.context.get(SKIP_ERROR_MODAL); //skip error modal if context token is set
        //show error dialog for other errors (not including logger service)
        if (!excludedErrorStatuses.includes(error.status) && !request.url.includes(environment.loggerApiUrl) && !skipErrorModal) {
          this.confirmationService.confirm({
            key: "errorDialog",
            header: this.translateService.instant("HOME.error_occurred_header"),
            closable: false,
            rejectVisible: false,
            acceptButtonProps: {
              label: this.translateService.instant("HOME.close"),
              severity: 'secondary',
              outlined: true,
              align: 'center'
            },
          });
        }
        return throwError(() => error);
      })
    );
  }
}

//context token to skip the error modal for specific requests
export const SKIP_ERROR_MODAL = new HttpContextToken<boolean>(() => false);
